import React from "react";
import { Phone } from "design_system/Icon";
import { NavBar as DSNav } from "widgets/NavBar";
import { Text } from "design_system/Text";
import { Color } from "../../utils/enums";

interface PhoneCTAProps {
    className?: string;
    providerPhoneNumber: string;
}
export const PhoneCTA = ({ className = "ml-auto", providerPhoneNumber }: PhoneCTAProps) => {
    return (
        <DSNav.TopBar.Link
            href={`tel:${providerPhoneNumber}`}
            leadingIcon={<Phone color={Color.WHITE} aria-hidden="true" />}
            className={className}
            data-test="button-phone"
        >
            <Text>{providerPhoneNumber}</Text>
        </DSNav.TopBar.Link>
    );
};
